'use strict'

import loadImage from 'blueimp-load-image/js/load-image'
import 'blueimp-load-image/js/load-image-orientation'
import 'blueimp-load-image/js/load-image-meta'
import 'blueimp-load-image/js/load-image-exif'

import { $log, $q } from '../helpers/angular-migration-helpers'

#runningFirefox = (navigator.userAgent.indexOf 'Firefox') > 0

defaultOptions =
  autoRotate: true
  cover: false
  maxWidth: 640
  maxHeight: 480
  maxResizes: 3

# Firefox seems to have some issues when rendering images to a canvas, so we will override the 'renderImageToCanvas'
# method, so we can catch this exception. Invalid images can also raise exceptions, so it's a good idea to do this
# always.
originalRenderMethod = loadImage.renderImageToCanvas
loadImage.renderImageToCanvas = (
  canvas
  img
  sourceX
  sourceY
  sourceWidth
  sourceHeight
  destX
  destY
  destWidth
  destHeight
) ->
  try
    originalRenderMethod(
      canvas
      img
      sourceX
      sourceY
      sourceWidth
      sourceHeight
      destX
      destY
      destWidth
      destHeight
    )
  catch e
    $log.warn(
      "Exception '#{e}' caught when rendering an image (#{img}) to canvas (#{canvas})"
    )
    null

resizeQueue = []
processQueue = ->
  # Obtain the first item from the queue
  if resizeQueue.length > 0
    [promise, callback] = resizeQueue[0]

    # Perform the actual resize operation
    callback()

    # Process the next items when the current item has finished processing
    promise.finally ->
      setTimeout(
        ->
          resizeQueue.shift()
          processQueue()
      ,
        50
      )

createContext = (width, height = width) ->
  # Create a canvas with the proper width and height
  canvas = document.createElement 'canvas'
  canvas.width = width
  canvas.height = height

  # Obtain the drawing context
  context = canvas.getContext '2d'

  # Enable image smoothing (should be already 'true' for most browsers)
  context.imageSmoothingEnabled = true

  # Return the drawing context
  context

export default
  # Get the developer mode setting
  resizeImage: (blob, options) ->
    dfd = $q.defer()
    callback = ->
      # Extend the options
      tempOptions = {}
      Object.assign tempOptions, defaultOptions, options

      # Filename required for debugging
      #if runningFirefox
      #  fileName = "#{blob.name}[#{blob.size} bytes #{tempOptions.maxWidth}x#{tempOptions.maxHeight}]"
      #  $log.debug "#{fileName}: Start resizing blob"

      # We need to load the image into a canvas
      loadImageOptions = canvas: true

      # Determine the maximum number of resizes that may be executed to get
      # the thumbnail size. Higher numbers result in better image quality,
      # but is more CPU-intensive. Setting this value to 0 means that it may
      # resize as often as is required. A value of 3 is typically fine.
      if tempOptions.maxResizes > 0 and tempOptions.maxResizes < 16
        loadImageOptions.maxWidth =
          tempOptions.maxWidth * (1 << tempOptions.maxResizes)
        loadImageOptions.maxHeight =
          tempOptions.maxHeight * (1 << tempOptions.maxResizes)

      # Parse the file's meta data (EXIF)
      loadImage.parseMetaData blob, (data) ->
        #if runningFirefox
        #  $log.debug "#{fileName}: Metadata parse callback invoked."

        # Obtain the orientation from the EXIF information
        if tempOptions.autoRotate and data.exif
          loadImageOptions.orientation = data.exif.get 'Orientation'

        # Load the actual image
        loadImage(
          blob
          (canvas) ->
            #if runningFirefox
            #  $log.debug "#{fileName}: Image loaded callback invoked..."

            # Reject with a null-canvas
            return dfd.reject 'null-canvas' if !canvas
            return dfd.reject 'no-context' if !canvas.getContext

            # Create a new canvas
            context = canvas.getContext '2d'
            altContext = null

            # Keep resizing, until the preview has the correct size. To prevent that we keep
            # needing new canvases, we use alternating canvases to draw on.
            width = canvas.width
            height = canvas.height
            while width > options.maxWidth and height > options.maxHeight
              # Determine the new width/height
              ratio = 0.5
              ratio = tempOptions.maxWidth / width if (
                width * ratio <
                tempOptions.maxWidth
              )
              ratio = tempOptions.maxHeight / height if (
                height * ratio <
                tempOptions.maxHeight
              )

              # Determine if need to do some cropping
              left = 0
              top = 0
              if tempOptions.cover
                if width > height
                  left = (width - height) / 2
                  width = height
                else if height > width
                  top = (height - width) / 2
                  height = width

              # Determine the new width/height
              newWidth = Math.round width * ratio
              newHeight = Math.round height * ratio

              # Draw onto the alternate canvas
              if !altContext
                #if runningFirefox
                #  $log.debug "#{fileName}: Creating #{newWidth}x#{newHeight} canvas"

                # Create the alternating context
                altContext = createContext newWidth, newHeight
              else
                # Resize the context
                altContext.canvas.width = newWidth
                altContext.canvas.height = newHeight

              #if runningFirefox
              #  $log.debug "#{fileName}: Drawing #{newWidth}x#{newHeight} image to canvas"

              # Redraw the image to the alternating canvas
              if left or top
                altContext.drawImage(
                  context.canvas
                  left
                  top
                  width
                  height
                  0
                  0
                  newWidth
                  newHeight
                )
              else
                altContext.drawImage context.canvas, 0, 0, newWidth, newHeight

              # Update height/width
              width = newWidth
              height = newHeight

              # Swap context
              tempContext = context
              context = altContext
              altContext = tempContext

            #if runningFirefox
            #  $log.debug "#{fileName}: Resize of image completed."

            # Resolve with specified context
            dfd.resolve context
        ,
          loadImageOptions
        )

        #if runningFirefox
        #  $log.debug "#{fileName}: Waiting for image to be loaded..."

      #if runningFirefox
      #  $log.debug "#{fileName}: Parsing metadata. Waiting for callback..."

    promise = dfd.promise
    resizeQueue.push [promise, callback]
    if resizeQueue.length is 1
      processQueue()

    promise
